module.exports = __webpack_public_path__ + "static/img/tab1-line-first.ce3358a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/tab1-line-first.png
// module id = 641
// module chunks = 12